import { toast } from "react-toastify";

export const toastSuccess = (message?: string) =>
  toast.success(message ? message : "Successfully");
export const toastError = (message?: string) =>
  toast.error(message ? message : "Error");
// export const toastInfo = (message: string) => toast.info(message);
// export const toastWarn = (message: string) => toast.warn(message);
